import axios from 'axios';

const baseUrl = `${process.env.VUE_APP_API_BASEURL}/Refferences`;
const headers = { 'Content-Type': 'application/json' };

export default {
  async getPlans() {
    const url = `${baseUrl}/plans`;
    const resp = await axios.get(url, { headers });
    return resp.data;
  },
};
